import { render } from "./CustomerTypesTable.vue?vue&type=template&id=06b79bc8&scoped=true"
import script from "./CustomerTypesTable.vue?vue&type=script&lang=js"
export * from "./CustomerTypesTable.vue?vue&type=script&lang=js"

import "./CustomerTypesTable.vue?vue&type=style&index=0&id=06b79bc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b79bc8"]])

export default __exports__